import { createContext, useEffect, useState, FC, ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { getTopic } from '../api/topics';
import { getUserInfoFromAzure, getUserInfoFromDb } from '../api/user';
import { checkPermissionTopic } from '../utils';

// components
import TermsModal from '../components/Terms/TermsModal';

// mui
import Box from "@mui/material/Box";
import Typography from '@mui/material/Typography';

// types
type AuthProps = {
    children: ReactNode
};

type AzureUserInfo = {
    id_token: string,
    provider_name: string,
    user_claims: {
        typ: string,
        val: string
    }[],
    user_id: string,
}[]

type DbUserInfo = {
    email: string,
    termsOfServiceConsent: boolean | null,
    userId: number,
    userName: string,
    rooms: {
        description: string,
        memberCount: number,
        name: string,
        roomId: number,
        thumbnailUrl: string,
    }[],
}

export const UserContext = createContext<DbUserInfo | undefined>(undefined);

const Auth: FC<AuthProps> = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState<DbUserInfo>();

    const fnGetAzureUserInfo = async () => {
        const result = await getUserInfoFromAzure() as AzureUserInfo;
        return result;
    };

    const fnGetDbUserInfo = async (userEmail: string) => {
        const result = await getUserInfoFromDb(userEmail) as DbUserInfo;
        return result;
    };

    // 認証チェック
    // ToDo:thenメソッドではなく、async awaitを使いたい
    useEffect(() => {
        fnGetAzureUserInfo()
            .then((result) => {
                // 認証チェック
                const emailClaim = result?.[0]?.user_claims?.find(claim => claim.typ === 'emails');
                return "ihori@opexpark.co.jp";
                //if (emailClaim === undefined) {
                //    window.location.href = '/.auth/login/aadb2c';
                //} else {
                //    return emailClaim.val;
                //}
            })
            .then((userEmail) => {
                // ユーザー情報取得
                if (userEmail) {
                    const result = fnGetDbUserInfo(userEmail);
                    return result;
                }
            })
            .then((result) => {
                // ユーザー情報セット
                setUserInfo(result);
            })
    }, []);

    // 利用規約モーダルの表示
    useEffect(() => {
        if (userInfo) {
            const isAgreedTerms = userInfo.termsOfServiceConsent;
            if (isAgreedTerms !== true) {
                setIsOpenTermsModal(true);
            }
        }
    }, [userInfo]);

    // アクセス権チェック
    useEffect(() => {
        if (userInfo) {
            // ルームアクセス権チェック
            const currentRoomId = location.pathname.split('/')[1];
            const userRoomIds = userInfo.rooms.map((room) => room.roomId);
            const numRegex = /^\d+$/;
            if (currentRoomId && numRegex.test(currentRoomId) && !userRoomIds.includes(Number(currentRoomId))) {
                navigate('/');
            }

            // トピックアクセス権チェック
            const currentTopicId = location.pathname.split('/')[3];
            const loginUserId = userInfo.userId;
            if (currentTopicId) {
                getTopic(currentTopicId)
                    .then((result) => {
                        const hasPermissionTopic = checkPermissionTopic(result.userId, result.topicMembers, loginUserId);
                        if (!hasPermissionTopic) {
                            navigate('/' + currentRoomId);
                        }
                    })
            }
        }
    }, [location.pathname, navigate, userInfo]);

    // 利用規約モーダル
    const [isOpenTermsModal, setIsOpenTermsModal] = useState<boolean>(false);
    const onCloseTermsModal = () => {
        setIsOpenTermsModal(false);
    }

    if (!userInfo) return (
        <Box sx={{ m: 2 }}>
            <Typography>ユーザー情報が取得できませんでした。<br />ページを再読み込みしてください。</Typography>
        </Box>
    );

    return (<>
        <UserContext.Provider value={userInfo}>
            {children}
        </UserContext.Provider>

        {/*利用規約モーダル*/}
        <TermsModal
            onClose={onCloseTermsModal}
            isOpen={isOpenTermsModal}
            userId={userInfo.userId}
        />
    </>)
}

export default Auth;
